export const NotificationSkeletonCard = () => {
  return (
    <div className='relative overflow-hidden flex items-center justify-between bg-skeleton border border-skeleton-border rounded-[30px] px-5 py-4 animate-pulse'>
      <div className='absolute top-2 right-2 rounded-full bg-skeleton-hi w-[32px] h-[32px]' />
      <div className=' flex flex-col gap-[7px] w-full'>
        <div className='h-[19px] w-[60%] rounded bg-skeleton-hi' />
        <div className='h-[22px] w-[80%] rounded bg-skeleton-hi' />
        <div className='h-[30px] w-[70%] rounded bg-skeleton-hi' />
      </div>
    </div>
  )
}
